/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { ActivateCollectionPatternMutation, ActivateCollectionPatternMutationVariables } from "@models/graphql";

const defaultActivateCollectionPatternOptions: MutationHookOptions<
    ActivateCollectionPatternMutation,
    ActivateCollectionPatternMutationVariables
> = {};

export const useActivateCollectionPattern = (
    options?: MutationHookOptions<ActivateCollectionPatternMutation, ActivateCollectionPatternMutationVariables>
) => {
    const [mutation, { data, loading, error }] = useMutation<ActivateCollectionPatternMutation, ActivateCollectionPatternMutationVariables>(
        GraphQLDocuments.activateCollectionPattern
    );

    const activateCollectionPattern = async (variables: ActivateCollectionPatternMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultActivateCollectionPatternOptions,
                ...options,
                variables
            });

            return {
                data: response.data,
                error: response.errors
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        activateCollectionPattern
    };
};
